module.exports = __webpack_public_path__ + "img/collage.2b0c5508.png";